import Callback from '@/services/Callback'
import To from 'await-to-js'
import qs from 'qs'
import { wizStandardInstance } from './instance'

export default class metadataManageService {
  // 获取类型下拉框数据
  static async getDbTypes(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/MetaDataManage/dbtypes?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取【记录分页列表】和【记录详情】
  static async getListOrDetail(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/MetaDataManage?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 获取频率下拉框数据
  static async getTypeList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/DicItem/get-item?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 新增
  static async createMatedata(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/MetaDataManage', payload))
    return Callback(err, res)
  }
  // 编辑
  static async patchMatedata(payload) {
    const [err, res] = await To(wizStandardInstance.patch('/api/MetaDataManage', payload))
    return Callback(err, res)
  }
  // 删除
  static async deleteMatedata(payload) {
    const [err, res] = await To(wizStandardInstance.delete('/api/MetaDataManage', payload))
    return Callback(err, res)
  }
  // 测试连接
  static async getConnection(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/MetaDataManage/test_connection?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 批量测试连接
  static async testConnection(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/MetaDataManage/test_connect', payload)
    )
    return Callback(err, res)
  }
  // 导出
  static async exportMatedata(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/MetaDataManage/export', payload, { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  // 判断表是否存在
  static async testExisttable(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/MetaDataManage/test_existtable?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
  // 下载模板
  static async downloadTemplate() {
    const [err, res] = await To(
      wizStandardInstance.get('/api/MetaDataManage/download_template', { responseType: 'blob' })
    )
    return Callback(err, res)
  }
  // 导入
  static async import(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/MetaDataManage/import_meta_data_manage', payload, {
        responseType: 'blob',
      })
    )
    return Callback(err, res)
  }
}
